import React from "react";
import { Link } from "react-router-dom";
import { brand } from "../mock";

export default function Footer() {
  const cols = [
    {
      title: brand.name,
      links: [
        ["About Us", "/about"],
        ["FAQ", "/faq"],
        ["Help", "/help"],
        ["Q&A", "/qa"],
        ["Contact Us", "/contact"],
        ["Press Center", "/press"],
      ],
    },
    {
      title: "For Consumers",
      links: [
        ["Submit Review", "/submit-review"],
        ["Browse Companies", "/browse"],
        ["Top Reviewers", "/top-reviewers"],
        ["Subscribe", "/subscribe"],
        ["How it Works", "/how-it-works"],
      ],
    },
    {
      title: "For Businesses",
      links: [
        ["Business Solutions", "/for-business"],
        ["Customer Support", "/business-support"],
        ["API Access", "/api"],
        ["Advertise", "/advertise"],
      ],
    },
    {
      title: "Resources",
      links: [
        ["Consumer Guides", "/guides"],
        ["Industry Reports", "/reports"],
        ["Collective Complaints", "/collective-complaints"],
        ["Glossary", "/glossary"],
        ["Sitemap", "/sitemap"],
      ],
    },
  ];
  return (
    <footer className="bg-[#003844] text-gray-300">
      <div className="max-w-[1200px] mx-auto px-4 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <div className="w-10 h-10 bg-[#f5a623] rounded-md flex items-center justify-center font-black text-[#003844]">RU</div>
              <div className="text-white font-bold">{brand.name}</div>
            </Link>
            <p className="text-xs leading-relaxed text-gray-400">
              {brand.tagline}. Help others by sharing your experience, and find honest reviews for any UK company.
            </p>
            <p className="text-[11px] text-gray-500 mt-3">{brand.domain}</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="text-white font-semibold text-sm mb-3">{c.title}</div>
              <ul className="space-y-2">
                {c.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-xs text-gray-400 hover:text-white hover:underline">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} {brand.name} Ltd. All rights reserved.</div>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-white">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
